import { render } from "./Feedback.vue?vue&type=template&id=ba58c9f2&scoped=true&lang=pug"
import script from "./Feedback.vue?vue&type=script&lang=js"
export * from "./Feedback.vue?vue&type=script&lang=js"

import "./Feedback.vue?vue&type=style&index=0&id=ba58c9f2&lang=scss"
import "./Feedback.vue?vue&type=style&index=1&id=ba58c9f2&lang=scss&scoped=true"
import "./Feedback.vue?vue&type=style&index=2&id=ba58c9f2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba58c9f2"]])

export default __exports__